/* eslint-disable no-shadow */
import React, { useState, useCallback } from 'react';
import { connect } from 'react-redux';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Row, Col, Label } from 'reactstrap';
import AddBoxNumber from './AddBoxNumber';
import { addNumberModalCancel, cancelAddNumber, editNumberCancel } from '../../../actions/Numbers';
import { getGateways } from '../../../actions/Provisioning';
import EditBoxNumber from './EditBoxNumber';
import Toggle from '../../Toggle';
import WarningModal from '../../WarningModal';
import { toast } from 'react-toastify';

const AddBoxNumberModal = ({
  isOpen,
  onConfirm,
  onCancel,
  boxDetails,
  cancelAddNumber,
  editNumberCancel,
  selectRoute,
  gateways,
  onEditPropertyKeyPress,
  vmail,
  port,
  editedNumber,
}) => {
  const [toggleState, setToggleState] = useState(false);
  const [confirmation, setConfirmation] = useState(false);
  const [e911Saving, setE911Saving] = useState(false);
  const [e911Handlers, setE911Handlers] = useState(null);

  const registerE911SaveHandler = useCallback(handlers => {
    setE911Handlers(handlers);
  }, []);

  const handleToggle = () => {
    setToggleState(!toggleState);
    cancelAddNumber();
    editNumberCancel();
  };

  const handleConfirm = async () => {
    if (port?.DTMFMethod == 'rfc2833' && editedNumber?.inbandRouting) {
      return toast.error('please disable inband route before using RFC');
    }
    if (editedNumber?.type === 'ringDown' && !editedNumber?.forwardUris?.length) {
      return toast.error('Ring down number is required');
    }

    // E911 address / reassignment prompts open on Save (Port Number flow)
    if (!toggleState && e911Handlers?.ensureBeforeSave) {
      setE911Saving(true);
      try {
        if (!(await e911Handlers.ensureBeforeSave())) return;
      } catch (error) {
        return;
      } finally {
        setE911Saving(false);
      }
    }

    setConfirmation(true);
  };

  const handleConfirmAtaWarning = async () => {
    setConfirmation(false);
    setE911Saving(true);
    try {
      await onConfirm(!toggleState);
      if (!toggleState && e911Handlers?.commitAfterAssign) {
        await e911Handlers.commitAfterAssign();
      }
    } finally {
      setE911Saving(false);
    }
  };

  return (
    <Modal size="lg" style={{ maxWidth: '900px' }} isOpen={isOpen}>
      <ModalHeader className="edit-number-port">
        Add new Number
        <Row hidden={vmail}>
          <Label for="enabled" sm={4}>
            Assign New Number
          </Label>
          <Col sm={3} style={{ marginTop: '8px' }}>
            <Toggle value={toggleState} onToggle={() => handleToggle()} />
          </Col>
          <Label for="enabled" sm={4}>
            Port Number
          </Label>
        </Row>
      </ModalHeader>
      <ModalBody>
        {toggleState ? (
          <AddBoxNumber toggleMode={toggleState} boxDetails={boxDetails} />
        ) : (
          <EditBoxNumber
            vmail={vmail}
            toggleMode={toggleState}
            selectRoute={selectRoute}
            gateways={gateways}
            boxDetails={boxDetails}
            onEditPropertyKeyPress={onEditPropertyKeyPress}
            registerE911SaveHandler={registerE911SaveHandler}
          />
        )}
      </ModalBody>
      <ModalFooter>
        <Button outline color="secondary" onClick={onCancel} id="port-cancel-btn">
          Cancel
        </Button>
        <Button
          color="primary"
          onClick={handleConfirm}
          id="port-save-btn"
          disabled={e911Saving}
        >
          Save
        </Button>
        <WarningModal
          isOpen={confirmation}
          onConfirm={handleConfirmAtaWarning}
          title="Warning"
          onCancel={() => setConfirmation(false)}
          body={
            'The ATA needs to be rebooted to configure the port and the affected ports will be offline for 3 minutes. Are you sure you want to proceed?'
          }
        />
      </ModalFooter>
    </Modal>
  );
};

const mapStateToProps = state => ({
  company: state.UIState.numbers.addNumber.company,
  type: state.UIState.numbers.addNumber.type,
  editedNumber: state.UIState.numbers.editNumber,
});

const mapDispatchToProps = dispatch => ({
  addNumberModalCancel: () => dispatch(addNumberModalCancel()),
  getGateways: token => dispatch(getGateways(token)),
  cancelAddNumber: () => dispatch(cancelAddNumber()),
  editNumberCancel: () => dispatch(editNumberCancel()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AddBoxNumberModal);
